<ng-template #gridExporter>   
    
    <button  igxButton (click)="exportButtonHandler()"
    class="btn-primary">
    <span class="icon icon-add-btn"></span>Export
</button>
</ng-template>